import React, { useEffect, useState } from "react";
import { Card, Switch, Tabs, Row, Col, message, Typography, Space, Divider } from "antd";
import { SettingOutlined, DesktopOutlined, TransactionOutlined } from "@ant-design/icons";
import axios from "axios";
import consts from "../../constant";
import Loadingpage from "../Loadingpage/Loadingpage";

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const UnderMaintenance = () => {
  const [load, setLoad] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [settings, setSettings] = useState({
    crm_maintenance: false,
    trade_maintenance: false,
    crm_pages: {},
    trade_pages: {}
  });

  const getSystemSettings = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${consts.BackendUrl}/settings/getSystemSettings`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
        },
      });
      if (response.data.success) {
        setSettings(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching system settings:", error);
      message.error("Failed to fetch settings");
    } finally {
      setLoad(false);
    }
  };

  const updateMaintenance = async (payload) => {
    try {
      const response = await axios.post(`${consts.BackendUrl}/settings/updateSystemSettings`, payload, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
        },
      });
      if (response.data.success) {
        setSettings(response.data.result);
        message.success("Maintenance settings updated successfully");
      }
    } catch (error) {
      message.error("Failed to update maintenance settings");
      console.error("Error updating system settings:", error);
    }
  };

  useEffect(() => {
    getSystemSettings();
  }, []);

  const handleTabChange = (key) => {
    setActiveTab(key);
    getSystemSettings();
  };

  const handlePageToggle = (system, page, value) => {
    const payload = {};
    if (system === "crm") {
      payload.crm_pages = { [page]: value };
    } else {
      payload.trade_pages = { [page]: value };
    }
    updateMaintenance(payload);
  };

  const crmPagesList = [
    { key: "dashboard", label: "Dashboard" },
    { key: "kyc", label: "KYC" },
    { key: "profile_update", label: "Profile Update" },
    { key: "deposit", label: "Deposit" },
    { key: "withdraw", label: "Withdraw" },
    { key: "wallet", label: "Wallet" },
    { key: "transfer", label: "Transfer" },
    // { key: "ib_dashboard", label: "IB Dashboard" },
    // { key: "ib_clients", label: "IB Clients" },
    // { key: "ib_reports", label: "IB Reports" },
    // { key: "ib_wallet", label: "IB Wallet" },
    // { key: "personal_detail", label: "Personal Detail" },
    // { key: "kycdetail", label: "KYC Detail" },
    // { key: "kyc_address", label: "KYC Address Verify" },
    // { key: "kyc_financial", label: "KYC Financial Source" },
    // { key: "document_declarations", label: "Document Declarations" },
    { key: "support", label: "Support" },
    { key: "security", label: "Security" },
  ];

  const tradePagesList = [
    { key: "dashboard", label: "Dashboard" },
    { key: "trade", label: "Trade" },
    // { key: "spinandwin", label: "Spin And Win" },
    { key: "history", label: "History" },
  ];

  const renderToggles = (system, list, pageSettings) => (
    <Row gutter={[16, 16]}>
      {list.map((item) => (
        <Col xs={24} sm={12} md={8} lg={6} key={item.key}>
          <Card
            size="small"
            className="card-bg-clr"
            style={{
              borderRadius: "12px",
              border: pageSettings?.[item.key] ? "1px solid #FC4420" : "1px solid rgba(255,255,255,0.1)",
              transition: "all 0.3s ease",
              background: pageSettings?.[item.key] ? "rgba(252, 68, 32, 0.05)" : "transparent"
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Text style={{ color: "#fff", fontWeight: 500 }}>{item.label}</Text>
              <Switch
                size="small"
                checked={pageSettings?.[item.key] || false}
                onChange={(checked) => handlePageToggle(system, item.key, checked)}
                style={{ backgroundColor: pageSettings?.[item.key] ? "#FC4420" : "#444" }}
              />
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );

  return (
    <div style={{ padding: "20px" }}>
      {load && <Loadingpage />}

      <div style={{ marginBottom: "30px", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <Title level={2} style={{ color: "#fff", margin: 0 }}>System Maintenance Control</Title>
          <Text style={{ color: "rgba(255,255,255,0.45)" }}>Manage individual page availability for CRM and Trade systems</Text>
        </div>
      </div>

      <Card className="card-bg-clr" style={{ borderRadius: "16px", border: "1px solid rgba(255,255,255,0.1)" }}>
        <Tabs activeKey={activeTab} onChange={handleTabChange} animated={{ inkBar: true, tabPane: true }}>
          <TabPane
            tab={<Space><DesktopOutlined /> CRM System</Space>}
            key="1"
          >
            <div style={{ padding: "10px 0" }}>
              <div style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: "15px", padding: "15px", background: "rgba(255,255,255,0.03)", borderRadius: "12px" }}>
                <Text style={{ color: "#fff", fontSize: "16px", fontWeight: 600 }}>Global CRM Maintenance</Text>
                <Switch
                  checked={settings.crm_maintenance}
                  onChange={(checked) => updateMaintenance({ crm_maintenance: checked })}
                  style={{ backgroundColor: settings.crm_maintenance ? "#FC4420" : "#444" }}
                />
                <Text style={{ color: "rgba(255,255,255,0.45)", fontSize: "12px" }}>* Enabling this will put the entire CRM under maintenance</Text>
              </div>
              <Divider orientation="left" style={{ borderColor: "rgba(255,255,255,0.1)" }}>
                <Text style={{ color: "rgba(255,255,255,0.45)", fontSize: "12px", textTransform: "uppercase", letterSpacing: "1px" }}>Individual Page Controls</Text>
              </Divider>
              {renderToggles("crm", crmPagesList, settings.crm_pages)}
            </div>
          </TabPane>
          <TabPane
            tab={<Space><TransactionOutlined /> Trade System</Space>}
            key="2"
          >
            <div style={{ padding: "10px 0" }}>
              <div style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: "15px", padding: "15px", background: "rgba(255,255,255,0.03)", borderRadius: "12px" }}>
                <Text style={{ color: "#fff", fontSize: "16px", fontWeight: 600 }}>Global Trade Maintenance</Text>
                <Switch
                  checked={settings.trade_maintenance}
                  onChange={(checked) => updateMaintenance({ trade_maintenance: checked })}
                  style={{ backgroundColor: settings.trade_maintenance ? "#FC4420" : "#444" }}
                />
                <Text style={{ color: "rgba(255,255,255,0.45)", fontSize: "12px" }}>* Enabling this will put the entire Trade system under maintenance</Text>
              </div>
              <Divider orientation="left" style={{ borderColor: "rgba(255,255,255,0.1)" }}>
                <Text style={{ color: "rgba(255,255,255,0.45)", fontSize: "12px", textTransform: "uppercase", letterSpacing: "1px" }}>Individual Page Controls</Text>
              </Divider>
              {renderToggles("trade", tradePagesList, settings.trade_pages)}
            </div>
          </TabPane>
        </Tabs>
      </Card>
      <style>
        {`
        .ant-tabs-tab {
          color: rgba(255, 255, 255, 0.45) !important;
          transition: all 0.3s ease !important;
        }
        .ant-tabs-tab:hover {
          color: #dccfccff !important;
        }
        .ant-tabs-tab-active .ant-tabs-tab-btn {
          color: #fff !important;
          font-weight: 600 !important;
        }
        .ant-tabs-ink-bar {
          background: #FC4420 !important;
          height: 3px !important;
        }
        .ant-tabs-nav::before {
          border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
        }
        `}
      </style>
    </div>
  );
};

export default UnderMaintenance;
